import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';

import TableSectionContext from './TableSectionContext';

import styles from './Table.module.scss';

const TableRow = ({
  children, onClick, selected, dataRow, otherSelected
}) => {
  const [mobileExpanded, setMobileExpanded] = useState(false);
  const tableSection = useContext(TableSectionContext);
  const {
    enqueueSnackbar,
  } = useSnackbar();

  return (
    <tr
      data-row={dataRow}
      data-mobile-expanded={mobileExpanded}
      className={`
        border-b border-dashed border-whiteHover dark:border-[#415a77]
        ${selected ? 'bg-input-bg dark:bg-[#415a77]' : ''}
        ${otherSelected ? 'bg-warning-light dark:bg-[#415a77] hover:cursor-not-allowed' : ''}
      `}
      role="presentation"
      onClick={() => {
        if (!otherSelected) {
          onClick?.();
        } else {
          enqueueSnackbar('This order is already selected by other user', {
            variant: 'warning',
            anchorOrigin: {
              vertical: 'top',
              horizontal: 'center',
            },
          });
        }
      }}
    >
      {children}
      {tableSection === 'body' && (
        <td className={styles.mobileControls} data-mobile-control="true">
          <button
            type="button"
            className={styles.mobileDetailsButton}
            aria-expanded={mobileExpanded}
            onClick={(event) => {
              event.stopPropagation();
              setMobileExpanded((expanded) => !expanded);
            }}
          >
            {mobileExpanded ? 'Hide details' : 'Show details'}
            <span aria-hidden="true">{mobileExpanded ? ' ↑' : ' ↓'}</span>
          </button>
        </td>
      )}
    </tr>
  );
};

TableRow.propTypes = {
  children: PropTypes.node,
  selected: PropTypes.bool,
  otherSelected: PropTypes.bool,
  onClick: PropTypes.func,
  dataRow: PropTypes.string,
};

TableRow.defaultProps = {
  children: undefined,
  selected: false,
  otherSelected: false,
  onClick: () => {},
  dataRow: ''
};

export default TableRow;
